const MODAL_ID = "won-parent-modal"

function createModalHtml(accountName, rootAccounts) {
  const options = rootAccounts
    .map(a => `<option value="${a.id}">${a.name}</option>`)
    .join("")

  return `
    <div id="${MODAL_ID}" class="modal" data-controller="modal" data-action="keydown.esc@window->modal#close">
      <div class="overlay" data-action="click->modal#close"></div>
      <div class="relative z-50 w-full max-w-lg">
        <div class="modal-panel">
          <div class="modal-header">
            <h3 class="text-lg font-semibold text-text-primary">Marquer comme gagné</h3>
            <button type="button" class="text-text-muted hover:text-text-primary" data-action="click->modal#close" data-cancel>
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div class="modal-body space-y-4">
            <p class="text-sm text-text-secondary">
              Le compte <strong class="text-text-primary">${accountName}</strong> va passer en client.
            </p>
            <div>
              <label class="block text-sm font-medium text-text-primary mb-1.5">
                Ce compte doit-il être rattaché à un compte parent ?
              </label>
              <select id="won-parent-select" class="input w-full">
                <option value="">Non, compte indépendant</option>
                ${options}
              </select>
            </div>
          </div>
          <div class="flex items-center justify-end gap-3 px-6 py-4 border-t border-border-subtle">
            <button type="button" class="btn btn-ghost" data-cancel>Annuler</button>
            <button type="button" class="btn btn-primary" data-confirm>Confirmer</button>
          </div>
        </div>
      </div>
    </div>
  `
}

function removeModal() {
  const existing = document.getElementById(MODAL_ID)
  if (existing) {
    existing.remove()
    document.body.classList.remove("overflow-hidden")
  }
}

export async function fetchWonData(dealId) {
  const csrf = document.querySelector('meta[name="csrf-token"]')?.content
  const response = await fetch(`/deals/${dealId}/won_data.json`, {
    headers: { "X-CSRF-Token": csrf, "Accept": "application/json" }
  })
  return response.json()
}

export function showWonModal(accountName, rootAccounts) {
  return new Promise((resolve) => {
    removeModal()

    const wrapper = document.createElement("div")
    wrapper.innerHTML = createModalHtml(accountName, rootAccounts)
    const modal = wrapper.firstElementChild
    document.body.appendChild(modal)
    document.body.classList.add("overflow-hidden")

    const select = modal.querySelector("#won-parent-select")

    modal.querySelector("[data-confirm]").addEventListener("click", () => {
      const parentId = select.value || null
      removeModal()
      resolve({ confirmed: true, parentAccountId: parentId })
    })

    modal.querySelectorAll("[data-cancel]").forEach(btn => {
      btn.addEventListener("click", () => {
        removeModal()
        resolve({ confirmed: false })
      })
    })

    modal.querySelector(".overlay").addEventListener("click", () => {
      removeModal()
      resolve({ confirmed: false })
    })
  })
}
